import { Box, Checkbox, Chip, Dialog, FormControlLabel, Grid, IconButton, Stack, Switch, TextField, Typography } from "@mui/material";
import SelectPeriodoSazonal, { SelectPeriodoVendasValues } from "../../../SelectPeriodoSazonal";
import EditIcon from '@mui/icons-material/Edit';
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import DialogContentSelecionarLoja, { TLoja } from "../../../DialogContentSelecionarLoja/DialogContentSelecionarLoja";
import { defValueLoja } from "../../../../types/api/geral/pesquisar-lojas";
import SearchIcon from '@mui/icons-material/Search';
import SelectQuery from "../../../SelectQuery";
import useDebounce from "../../../../lib/useDebounce";
import { filtrosPreDefinidos } from "./filtrosPredefinidos";
import { FiltrosPreDefinidos, InputsSelecionarProduto } from "..";
import ModalSelectQtdSugestion from "./ModalSelectQtdSugestion";
import ModalOrigemDestino from "./ModalOrigemDestino";
import { AuthContext } from "../../../../contexts/AuthContext";

export default function Filtros({
    isRessuprimento = false
}: FiltrosProps) {

    const { userPerfilComLoja } = useContext(AuthContext);

    const [searchTerm, setSearchTerm] = useState<string>("");
    const [openModalQtdSugestion, setOpenModalQtdSugestion] = useState(false)
    const [openSelectModal, setOpenSelectModal] = useState(false)

    const debouncedSearchTerm = useDebounce(searchTerm);

    const niveisEstoqueOptions = useMemo(() => [
        { value: "0a15", label: "0 a 15 dias" },
        { value: "16a30", label: "16 a 30 dias" },
        { value: "31a60", label: "31 a 60 dias" },
        { value: "60mais", label: "> 60 dias" }
    ], [])

    const { control, getValues, setValue, watch } = useFormContext<InputsSelecionarProduto>()

    // Funções manipuladoras
    const handleSelectPreFilter = useCallback((itemSelecionado: FiltrosPreDefinidos) => {
        setValue('filters.predSelecionado', itemSelecionado);
        setValue('filters.departamentos', itemSelecionado.filtros.departamentos);
        setValue('filters.origem', itemSelecionado.filtros.origem);
    }, [setValue])

    const handleSelectNiveisEstoque = useCallback((value: string) => {
        const values = getValues('filters');
        const niveisEstq = [...values.niveis_estoque]

        const index = niveisEstq.indexOf(value);
        if (index !== -1) niveisEstq.splice(index, 1);
        if (index === -1) niveisEstq.push(value);

        setValue('filters.niveis_estoque', niveisEstq);
    }, [setValue, getValues])
    //

    useEffect(() => {
        setValue('filters.palavra_chave', `${debouncedSearchTerm}`);
    }, [debouncedSearchTerm, setValue]);

    return (
        <>
            <Grid container justifyContent="space-between" p={1} mt={4}>
                <Grid display="flex" alignItems="center">
                    <Stack direction={'column'}>
                        <Box>
                            <Controller
                                name="filters.destino"
                                control={control}
                                rules={{ required: 'Campo obrigatório' }}
                                render={({ field, fieldState: { error } }) => (
                                    <Box>
                                        <Typography fontSize={12}>Loja solicitante</Typography>
                                        <Typography fontSize={18}>{getValues('filters.calcular_nivel_global') ? '-' : field.value?.nome || "-"}</Typography>
                                    </Box>
                                )}
                            />
                            {
                                !isRessuprimento && !userPerfilComLoja &&
                                <IconButton onClick={() => setOpenSelectModal(true)} aria-label="edit" size="small" sx={{ marginLeft: 1 }}>
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            }
                        </Box>
                        {
                            !isRessuprimento &&
                            <Controller
                                name="filters.calcular_nivel_global"
                                control={control}
                                rules={{ required: 'Campo obrigatório' }}
                                render={({ field, fieldState: { error } }) => {
                                    return (
                                        <Box>
                                            <FormControlLabel
                                                label={"Estoque Global"}
                                                control={<Checkbox checked={field.value} size="small" />}
                                                onChange={() => {
                                                    field.onChange(!field.value)
                                                }}
                                            />
                                        </Box>
                                    )
                                }}
                            />
                        }
                    </Stack>
                </Grid>
                <Grid>
                    <SelectPeriodoSazonal
                        prevValues={{
                            periodo_inicio: watch('filters').periodo_vendas_inicio,
                            periodo_fim: watch('filters').periodo_vendas_fim,
                            sazonalidade_inicio: watch('filters').sazonalidade_inicio,
                            sazonalidade_fim: watch('filters').sazonalidade_fim
                        }}
                        onChange={(values: SelectPeriodoVendasValues) => {
                            setValue("filters.periodo_vendas_inicio", values.periodo_inicio)
                            setValue("filters.periodo_vendas_fim", values.periodo_fim)
                            setValue("filters.sazonalidade_inicio", values.sazonalidade_inicio)
                            setValue("filters.sazonalidade_fim", values.sazonalidade_fim)
                        }} />
                </Grid>
                <Grid display="flex" alignItems="center">
                    <Box>
                        <Typography fontSize={12}>Sugerir quantidades para</Typography>
                        <Typography fontSize={18}>{getValues('filters').qtdSuggestion} dia(s)</Typography>
                    </Box>
                    <IconButton onClick={() => setOpenModalQtdSugestion(true)} aria-label="edit" size="small" sx={{ marginLeft: 1 }}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Grid>
            </Grid>
            <Grid container display="flex" mt={1} spacing={2}>

                <Grid size={{ xs: 12, md: 6 }}>
                    <Controller
                        name="filters.palavra_chave"
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error } }) => (
                            <TextField
                                fullWidth
                                label="Pesquisar"
                                value={searchTerm}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)}
                                slotProps={{
                                    input: {
                                        endAdornment: <SearchIcon />
                                    }
                                }}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 2 }}>
                    <Controller
                        name="filters.departamentos"
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error } }) => (
                            <SelectQuery
                                query="estoque/pesquisar-departamentos"
                                type="field"
                                label="Departamento"
                                titleModal="Selecionar departamento"
                                emptyLabel="Todos"
                                returnOnlyId={false}
                                multiple={true}
                                defaultValue={field.value?.map(i => ({ id: i.id, nome: i.nome }))}
                                onChange={(values) => {
                                    field.onChange(values);
                                }}
                            />
                        )}
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 2 }}>
                    <Controller
                        name="filters.setores"
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error } }) => (
                            <SelectQuery
                                query="estoque/pesquisar-setores"
                                label="Setor"
                                type="field"
                                titleModal="Selecionar setor"
                                emptyLabel="Todos"
                                multiple={true}
                                onChange={(values) => {
                                    field.onChange(values);
                                }}
                            />
                        )}
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 2 }}>
                    <Controller
                        name="filters.sazonalidades_ids"
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error } }) => (
                            <SelectQuery
                                query="estoque/configuracoes/pesquisar-sazonalidades-vendas"
                                label="Sazonalidade"
                                type="field"
                                titleModal="Selecionar sazonalidade"
                                emptyLabel="Todas"
                                multiple={true}
                                onChange={(values) => {
                                    field.onChange(values);
                                }}
                            />
                        )}
                    />

                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography fontSize={12} mt={1} mb={1}>Filtros pré definidos</Typography>
                    {
                        filtrosPreDefinidos.map((i: FiltrosPreDefinidos, index: number) =>
                            <Controller
                                key={index}
                                name="filters.predSelecionado"
                                control={control}
                                rules={{ required: 'Campo obrigatório' }}
                                render={({ field, fieldState: { error } }) => (
                                    <Chip
                                        key={index}
                                        label={i.nome}
                                        style={{ marginRight: 4 }}
                                        onClick={() => handleSelectPreFilter(i)}
                                        color={field.value?.nome === i.nome ? 'primary' : 'default'}
                                        variant={field.value?.nome === i.nome ? 'filled' : 'outlined'}
                                    />
                                )}
                            />
                        )
                    }
                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography fontSize={12} mt={1} mb={1}>Mostrar items</Typography>
                    <Stack direction="row" spacing={2}>
                        <Controller
                            name="filters.mostrar_itens_sem_estoque_origem"
                            control={control}
                            rules={{ required: 'Campo obrigatório' }}
                            render={({ field, fieldState: { error } }) => (
                                <FormControlLabel
                                    label="Sem estoque na origem"
                                    control={
                                        <Switch
                                            size="small"
                                            checked={field.value}
                                            onChange={(e) => {
                                                field.onChange(e.target.checked);
                                            }}
                                        />
                                    }
                                    componentsProps={{
                                        typography: {
                                            variant: "subtitle2"
                                        }
                                    }}
                                />
                            )}
                        />

                    </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography fontSize={12} mt={1} mb={1}>Filtrar por nível de estoque</Typography>
                    <Controller
                        name="filters.niveis_estoque"
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error } }) => (
                            <Box>
                                {
                                    niveisEstoqueOptions.map((item, index) => {
                                        const isChecked = field.value.includes(item.value)
                                        return (
                                            <FormControlLabel
                                                key={index}
                                                label={item.label}
                                                control={<Checkbox checked={isChecked} size="small" />}
                                                onChange={() => handleSelectNiveisEstoque(item.value)}
                                            />
                                        )
                                    })
                                }
                            </Box>
                        )}
                    />

                </Grid>
            </Grid>

            {
                openSelectModal && !isRessuprimento &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openSelectModal}
                    onClose={() => setOpenSelectModal(false)}
                >
                    <Controller
                        name="filters.destino"
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error } }) => (
                            <DialogContentSelecionarLoja
                                autoSelecionarPrimeiro
                                handleClose={() => setOpenSelectModal(false)}
                                defaultValue={field.value
                                    ? field.value
                                    : defValueLoja
                                }
                                onChange={(value) => {
                                    field.onChange(value as TLoja)
                                    setOpenSelectModal(false)
                                }}
                            />
                        )}
                    />

                </Dialog>
            }
            {
                openSelectModal && isRessuprimento &&
                <ModalOrigemDestino
                    values={getValues('filters')}
                    isFirstFilled={userPerfilComLoja?.loja ? false : true}
                    open={openSelectModal}
                    handleClose={() => {
                        setOpenSelectModal(false)
                    }}
                    onChangeOrigem={(value) => {
                        setValue('filters.origem', value)
                    }}
                    onChangeDestino={(value) => {
                        setValue('filters.destino', value)
                    }}
                />
            }
            {
                openModalQtdSugestion &&
                <ModalSelectQtdSugestion
                    open={openModalQtdSugestion}
                    qtdValue={getValues('filters').qtdSuggestion}
                    handleClose={() => setOpenModalQtdSugestion(false)}
                    onSubmit={(value) => setValue('filters.qtdSuggestion', value)}
                />
            }
        </>
    )
}

interface FiltrosProps {
    isRessuprimento?: boolean
}
